/*
 * Irotama Resort
 */
const factory = function factory({ thn }) {
    return {
        onStateChange: thn.debounce(() => {
            thn.pageCheck();
        }, 700),
    };
};

export { factory };
